<dashboard-loader *ngIf="loadingTemplates$ | async" [title]="'Loading templates...'"></dashboard-loader>
<div *ngIf="templatesLoaded$ | async">
  <div class="dashboard-template" fxLayout="row" fxLayoutAlign="space-around start" fxLayoutGap="20px">
    <div
      class="dashboard-template__left"
      fxLayout="column"
      fxLayoutAlign="space-around start"
      fxLayoutGap="20px"
      fxFlex="40"
    >
      <h1 class="dashboard-template__left-title">Templates</h1>
      <div class="dashboard-template__left-button" fxLayout="row" fxLayoutGap="10px" fxFill>
        <button mat-raised-button color="accent" (click)="openImportTemplate()">
          {{ 'Import' | uppercase }}
        </button>
        <button mat-raised-button color="accent" (click)="createTemplate()" [disabled]="!isEdit">
          {{ 'Create New Template' | uppercase }}
        </button>
      </div>
      <mat-card *ngIf="templates && templates.length === 0">
        There are no templates that you can view or edit
      </mat-card>
      <div fxFill>
        <virtual-scroller #scroll class="dashboard-template__left-scroll" [items]="templates">
          <mat-card
            *ngFor="let template of scroll.viewPortItems"
            class="dashboard-template__left-scroll-templates-card"
          >
            <mat-card-header>
              <mat-card-title class="dashboard-template__left-scroll-templates-card-title">
                <div fxLayout="row" fxLayoutAlign="space-between">
                  <span>{{ template?.templateName }}</span>
                  <span>
                    {{
                      template?.interventionName?.length > interventionNameLengthLimit
                        ? (template?.interventionName | slice: 0:interventionNameLengthLimit) + '...'
                        : template?.interventionName
                    }}
                  </span>
                </div>
              </mat-card-title>
            </mat-card-header>
            <mat-card-content class="dashboard-template__left-scroll-templates-card-content">
              <div class="dashboard-template__left-scroll-templates-card-content__url">
                <label class="dashboard-template__left-scroll-templates-card-content__url-label"> Preview link: </label>
                <a
                  target="_blank"
                  class="dashboard-template__left-scroll-templates-card-content__url-link"
                  [attr.href]="ccFeedbackUrl + '/' + template?.hash"
                >
                  {{ ccFeedbackUrl + '/' + template?.hash }}
                </a>
              </div>
            </mat-card-content>
            <mat-divider [inset]="true"></mat-divider>
            <mat-card-actions fxLayout="row" fxLayoutAlign="end center">
              <ng-container>
                <button mat-button (click)="exportTemplate(template)">{{ 'Export' | uppercase }}</button>
                <button mat-button color="warn" (click)="openDeleteTemplateDialog(template)">
                  {{ 'Delete' | uppercase }}
                </button>
                <button mat-button (click)="openTemplateDetails(template)">
                  {{ 'Open' | uppercase }}
                </button>
              </ng-container>
            </mat-card-actions>
          </mat-card>
        </virtual-scroller>
      </div>
    </div>
    <div class="dashboard-template__center">
      <div class="dashboard-template__center-line"></div>
    </div>
    <div
      class="dashboard-template__right"
      fxLayout="column"
      fxLayoutAlign="space-around strech"
      fxLayoutGap="40px"
      fxFlex="50"
    >
      <div *ngIf="isEdit; else newTemplate">
        <mat-tab-group
          mat-stretch-tabs
          dynamicHeight
          #tabs
          class="dashboard-template__right-group"
          fxLayout="column"
          fxLayoutAlign="center"
          fxFill
        >
          <mat-tab label="GENERAL">
            <dashboard-template-form
              [isEdit]="isEdit"
              [availableInterventions]="availableInterventions"
              fxFill
            ></dashboard-template-form>
          </mat-tab>
          <mat-tab label="SECTIONS" [disabled]="!selectedTemplate?.interventionId">
            <ng-template mat-tab-label>
              <label
                matTooltipPosition="above"
                [matTooltip]="
                  selectedTemplate?.interventionId
                    ? null
                    : 'Please connect template with an intervention in order to continue working on it!'
                "
                >SECTIONS
              </label>
            </ng-template>
            <dashboard-sections></dashboard-sections>
          </mat-tab>
        </mat-tab-group>
      </div>
      <ng-template #newTemplate>
        <h1 class="dashboard-template__right-title">Template</h1>
        <dashboard-template-form
          [isEdit]="isEdit"
          [availableInterventions]="availableInterventions"
          fxFill
        ></dashboard-template-form>
      </ng-template>
    </div>
  </div>
</div>
